import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    CLASSNAME
} from '../../../business-const/Style/Style'

import {
    formataTableCellHeadExibeDadosValor,
    formataTableCellHeadExibeDadosTextoQuebraEspecial,
    formataTableCellHeadExibeDadosValorQuebraEspecial,
    formataTableCellBodyExibeDadosTexto,
    formataTableCellBodyExibeDadosValor,
} from '../../../business-components/Formata/Formata'

import {
    DivFormEstudo,
} from '../../../business-components/Div/Div'

import {
    CardGridDivBody,
} from '../../../business-components/Card/Card'

import {
    formataData,
} from '../../../business-components/Date/Date'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import {
    possuiFGTS
} from '../garantias-form/GarantiasServiceRecursosFinanceiros'



const EstudoReportConferenciaDadosParametros = ( { values, report } ) => {
    
    const ConferenciaDadosParametros = () => {

        const aumentoLetraCabecalho = 1
        const aumentoLetraReportCabecalho = 1

        const aumentoLetra = 2
        const aumentoLetraReport = values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato ? 2 : 1

        const possuiFGTSAux = possuiFGTS(values)

        const possuiCDI =
            (values.taxaCDIAnual || values.retornoCDI || values.taxaCDIAnualAposAposentadoria || values.retornoCDIAposAposentadoria) &&
            !values.utilizarPercRentabilidadeAnualRecursosFinanceiros ? true : false
    
        const parametros = []

        parametros.push({
            periodo: LABEL.ateAposentadoria,
            taxaCDIAnual: values.taxaCDIAnual,
            retornoCDI: values.retornoCDI,
            taxaJurosAnualPonderada:
                values.tabClienteFormList === LABEL.tabClienteFormListPrevidenciaPrivada
                    ?
                        values.taxaJurosAnual
                    :
                        values.taxaJurosAnualPonderada,
            taxaInflacaoAnual: values.taxaInflacaoAnual,
            taxaRetornoAnualRealPonderada:
                values.tabClienteFormList === LABEL.tabClienteFormListPrevidenciaPrivada
                    ?
                        values.taxaRetornoAnualReal
                    :
                        values.taxaRetornoAnualRealPonderada,
            taxaJurosAnualFgts: values.taxaJurosAnualFgts,
            taxaRetornoAnualFgtsReal: values.taxaRetornoAnualFgtsReal,
        })

        if (values.diferenciarTaxasAposAposentadoria) {

            parametros.push({
                periodo: LABEL.aposAposentadoria,
                taxaCDIAnual: values.taxaCDIAnualAposAposentadoria,
                retornoCDI: values.retornoCDIAposAposentadoria,
                taxaJurosAnualPonderada: values.taxaJurosAnualAposAposentadoria,
                taxaInflacaoAnual: values.taxaInflacaoAnualAposAposentadoria,
                taxaRetornoAnualRealPonderada: values.taxaRetornoAnualRealAposAposentadoria,
                taxaJurosAnualFgts: values.taxaJurosAnualFgtsAposAposentadoria,
                taxaRetornoAnualFgtsReal: values.taxaRetornoAnualFgtsRealAposAposentadoria,
            })
        }

        let colSpan0 = 0
        let colSpan1 = 0
        let colSpan2

        let headList = []

        if (values.diferenciarTaxasAposAposentadoria) {

            headList.push(
                {
                    colSpan: 5,
                    headTitle: formataTableCellHeadExibeDadosValor(LABEL.periodo, report, aumentoLetraCabecalho,
                        aumentoLetraReportCabecalho, values),
                },
            )

            colSpan0 += 1
            colSpan1 += 1
        }

        if (possuiCDI) {
            
            headList.push(
                {
                    colSpan: 2,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.taxaCDIAnualQuebraEspecial, report,
                        aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                },
                {
                    colSpan: 3,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.retornoCDIQuebraEspecial, report,
                        aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                },
            )

            colSpan1 += 2
        }
            
        headList.push(
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.taxaJurosQuebraEspecial, report,
                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.taxaInflacaoAnualQuebraEspecial, report,
                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.taxaRetornoAnualRealQuebraEspecial, report,
                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
        )

        if (possuiFGTSAux) {

            headList.push(
                {
                    colSpan: 3,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.taxaJurosAnualFgtsQuebraEspecial, report,
                        aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                },
                {
                    colSpan: 4,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.taxaRetornoAnualFgtsRealQuebraEspecial, report,
                        aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                },
            )

            colSpan2 = colSpan1 + 5
            
        } else {

            colSpan2 = colSpan1 + 3
        }

        headList.push(
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosTextoQuebraEspecial(LABEL.dataSimulacaoEstudoQuebraEspecial, report,
                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
        )

        return (
            <TableExibeDados
                report={report}
                noMinW={true} // tratamento para não ter diferenciação do tamanho de letra no relatório
            >
                <TableHeadExibeDados
                    report={report}
                >
                    <TableRowHeadExibeDados
                        dados={headList}
                    />
                </TableHeadExibeDados>

                <TableBodyExibeDados>
                    {parametros?.map((item, ind) => {
                        return (
                            <TableRowBodyExibeDados
                                key={ind}
                                report={report}
                            >
                                {values.diferenciarTaxasAposAposentadoria && (
                                    <TableCellBodyExibeDados
                                            colSpan={headList[0].colSpan}
                                            primeiraColuna={true}
                                        >
                                            {formataTableCellBodyExibeDadosTexto(item.periodo, report, false,
                                                aumentoLetra, aumentoLetraReport, values)}
                                        </TableCellBodyExibeDados>
                                        
                                )}

                                {possuiCDI && (
                                    <>
                                        <TableCellBodyExibeDados
                                            colSpan={headList[colSpan0].colSpan}
                                            primeiraColuna={colSpan0 !== 1}
                                        >
                                            {formataTableCellBodyExibeDadosValor(item.taxaCDIAnual, report,
                                                false, true, aumentoLetra, aumentoLetraReport, values)}
                                        </TableCellBodyExibeDados>
                                        
                                        <TableCellBodyExibeDados
                                            colSpan={headList[colSpan0 + 1].colSpan}
                                        >
                                            {formataTableCellBodyExibeDadosValor(item.retornoCDI, report,
                                                false, true, aumentoLetra, aumentoLetraReport, values)}
                                        </TableCellBodyExibeDados>
                                    </>
                                )}
                                
                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan1].colSpan}
                                    primeiraColuna={!values.diferenciarTaxasAposAposentadoria && !possuiCDI}
                                >
                                    {formataTableCellBodyExibeDadosValor(item.taxaJurosAnualPonderada, report,
                                        false, true, aumentoLetra, aumentoLetraReport, values)}
                                </TableCellBodyExibeDados>
                                
                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan1 + 1].colSpan}
                                >
                                    {formataTableCellBodyExibeDadosValor(item.taxaInflacaoAnual, report,
                                        false, true, aumentoLetra, aumentoLetraReport, values)}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan1 + 2].colSpan}
                                >
                                    {formataTableCellBodyExibeDadosValor(item.taxaRetornoAnualRealPonderada,
                                        report, false, true, aumentoLetra, aumentoLetraReport, values)}
                                </TableCellBodyExibeDados>

                                {possuiFGTSAux && (
                                    <>
                                        <TableCellBodyExibeDados
                                            colSpan={headList[colSpan1 + 3].colSpan}
                                        >
                                            {formataTableCellBodyExibeDadosValor(item.taxaJurosAnualFgts,
                                                report, false, true, aumentoLetra, aumentoLetraReport, values)}
                                        </TableCellBodyExibeDados>
                                        
                                        <TableCellBodyExibeDados
                                            colSpan={headList[colSpan1 + 4].colSpan}
                                        >
                                            {formataTableCellBodyExibeDadosValor(item.taxaRetornoAnualFgtsReal,
                                                report, false, true, aumentoLetra, aumentoLetraReport, values)}
                                        </TableCellBodyExibeDados>
                                    </>
                                )}
                                
                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan2].colSpan}
                                >
                                    {formataTableCellBodyExibeDadosTexto(
                                        formataData(values.dataSimulacaoEstudo), report, false,
                                        aumentoLetra, aumentoLetraReport, values)}
                                </TableCellBodyExibeDados>
                            </TableRowBodyExibeDados>
                        )
                    })}
                </TableBodyExibeDados>
            </TableExibeDados>
        )
    }



    return (
        <DivFormEstudo>
            <div
                align="center"
                className={CLASSNAME().formataReportConferenciaDadosCabecalho}
            >
                {LABEL.parametros.toUpperCase() /* mudança da fonte: uppercase */}
            </div>

            <CardGridDivBody>
                <ConferenciaDadosParametros/>
            </CardGridDivBody>
        </DivFormEstudo>
    )
}

export default EstudoReportConferenciaDadosParametros